<template>
  <div v-if="visivel" class="comb-modal-overlay" @click.self="$emit('fechar')">
    <div class="comb-modal">
      <div class="comb-modal__header">
        <h3 class="comb-modal__title">
          <i class="fas fa-layer-group"></i>
          Selecionar Combinação
        </h3>
        <button class="comb-modal__close" @click="$emit('fechar')">×</button>
      </div>

      <div v-if="produto" class="comb-modal__produto">
        <span class="comb-modal__produto-nome">{{ produto.descricao }}</span>
      </div>

      <div class="comb-modal__busca">
        <input
          v-model="filtro"
          type="text"
          class="comb-modal__busca-input"
          placeholder="Filtrar combinações..."
          @input="filtrar"
        />
      </div>

      <div v-if="!opcoesVisiveis || opcoesVisiveis.length === 0" class="comb-modal__vazio">
        <i class="fas fa-exclamation-circle"></i>
        Nenhuma combinação encontrada para este produto.
      </div>

      <div v-else class="comb-modal__lista">
        <div
          v-for="opcao in opcoesVisiveis"
          :key="opcao.chave"
          class="comb-modal__item"
          :class="{
            'comb-modal__item--selecionado': selecionadoChave === opcao.chave,
            'comb-modal__item--esgotado': opcao.quantidadeEstoque === 0
          }"
          @click="selecionar(opcao)"
        >
          <div class="comb-modal__item-info">
            <span class="comb-modal__item-nome">{{ opcao.descricao }}</span>
            <span
              v-if="opcao.quantidadeEstoque !== null"
              class="comb-modal__item-estoque"
              :class="{ 'comb-modal__item-estoque--esgotado': opcao.quantidadeEstoque === 0, 'comb-modal__item-estoque--baixo': opcao.quantidadeEstoque > 0 && opcao.quantidadeEstoque <= 3 }"
            >
              {{ opcao.quantidadeEstoque === 0 ? 'Esgotado' : `Estoque: ${opcao.quantidadeEstoque}` }}
            </span>
          </div>

          <div class="comb-modal__item-acoes">
            <div v-if="selecionadoChave === opcao.chave" class="comb-modal__qty-wrap" @click.stop>
              <button class="comb-modal__qty-btn" @click.stop="decrementar">−</button>
              <input
                v-model.number="quantidade"
                type="number"
                min="1"
                class="comb-modal__qty-input"
                @click.stop
              />
              <button class="comb-modal__qty-btn" @click.stop="incrementar(opcao)">+</button>
            </div>
            <button
              class="comb-modal__btn-selecionar"
              :class="{ 'comb-modal__btn-selecionar--ativo': selecionadoChave === opcao.chave }"
              :disabled="opcao.quantidadeEstoque === 0"
              @click.stop="selecionar(opcao)"
            >
              <i class="fas fa-check"></i>
              {{ selecionadoChave === opcao.chave ? 'Selecionado' : 'Selecionar' }}
            </button>
          </div>
        </div>
      </div>

      <div v-if="erro" class="comb-modal__erro">
        <i class="fas fa-exclamation-circle"></i> {{ erro }}
      </div>

      <div class="comb-modal__footer">
        <button class="comb-modal__btn comb-modal__btn--cancel" @click="$emit('fechar')">
          Cancelar
        </button>
        <button
          class="comb-modal__btn comb-modal__btn--confirm"
          :disabled="!selecionadoChave"
          @click="confirmar"
        >
          <i class="fas fa-check"></i> Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CombinacaoProdutoModalPdv",

  props: {
    visivel:     { type: Boolean, default: false },
    produto:     { type: Object,  default: null },
    combinacoes: { type: Array,   default: () => [] },
  },

  data() {
    return {
      selecionadoChave: null,
      opcaoSelecionada: null,
      filtro: "",
      todasOpcoes: [],
      opcoesVisiveis: [],
      quantidade: 1,
      erro: "",
    };
  },

  watch: {
    visivel(val) {
      if (val) {
        this.selecionadoChave = null;
        this.opcaoSelecionada = null;
        this.filtro = "";
        this.erro = "";
        this.quantidade = 1;
        this._parsearOpcoes();
        if (this.todasOpcoes.length === 1) {
          this.selecionar(this.todasOpcoes[0]);
        }
      }
    },
    combinacoes() {
      this._parsearOpcoes();
    },
  },

  methods: {
    _parsearOpcoes() {
      const opcoes = [];

      for (const comb of (this.combinacoes || [])) {
        const jsonRaw = comb.combinacao_json;
        let parsed = null;

        if (typeof jsonRaw === "string") {
          try { parsed = JSON.parse(jsonRaw); } catch { /* não é JSON */ }
        } else if (Array.isArray(jsonRaw)) {
          parsed = jsonRaw;
        } else if (jsonRaw && typeof jsonRaw === "object") {
          parsed = [jsonRaw];
        }

        if (Array.isArray(parsed)) {
          parsed.forEach((item, idx) => {
            const quantidadeEstoque = item.quantidade !== undefined ? Number(item.quantidade) : null;
            const varKeys = Object.keys(item).filter(k => k !== "quantidade");

            let descricao = "";
            if (varKeys.length > 0) {
              descricao = varKeys.map(k => {
                const val = item[k];
                if (val && typeof val === "object") {
                  return `${k}: ${val.nome ?? val.name ?? JSON.stringify(val)}`;
                }
                return `${k}: ${val}`;
              }).join(" | ");
            } else {
              descricao = comb.descricao_combinacao || `Combinação ${idx + 1}`;
            }

            opcoes.push({
              chave: `${comb.id_produto_combinacao}_${idx}`,
              descricao,
              quantidadeEstoque,
              combinacaoOriginal: comb,
              itemVariacao: item,
            });
          });
        } else {
          opcoes.push({
            chave: String(comb.id_produto_combinacao),
            descricao: comb.descricao_combinacao || String(comb.combinacao_json || "—"),
            quantidadeEstoque: null,
            combinacaoOriginal: comb,
            itemVariacao: null,
          });
        }
      }

      this.todasOpcoes = opcoes;
      this.aplicarFiltro();
    },

    selecionar(opcao) {
      if (opcao.quantidadeEstoque === 0) return;
      this.selecionadoChave = opcao.chave;
      this.opcaoSelecionada = opcao;
      this.quantidade = 1;
      this.erro = "";
    },

    decrementar() {
      if (this.quantidade > 1) this.quantidade--;
    },

    incrementar(opcao) {
      const max = opcao.quantidadeEstoque;
      if (max !== null && this.quantidade >= max) return;
      this.quantidade++;
    },

    filtrar() {
      this.aplicarFiltro();
    },

    aplicarFiltro() {
      const termo = (this.filtro || "").toLowerCase().trim();
      if (!termo) {
        this.opcoesVisiveis = [...this.todasOpcoes];
      } else {
        this.opcoesVisiveis = this.todasOpcoes.filter(o =>
          o.descricao.toLowerCase().includes(termo)
        );
      }
    },

    confirmar() {
      this.erro = "";

      if (!this.opcaoSelecionada) {
        this.erro = "Selecione uma combinação.";
        return;
      }

      const qty = Number(this.quantidade) || 1;
      if (qty < 1) {
        this.erro = "Informe uma quantidade válida.";
        return;
      }

      const estoque = this.opcaoSelecionada.quantidadeEstoque;
      if (estoque !== null && qty > estoque) {
        this.erro = `Quantidade máxima disponível: ${estoque}`;
        return;
      }

      const combinacaoData = {
        ...this.opcaoSelecionada.combinacaoOriginal,
        descricao_combinacao: this.opcaoSelecionada.descricao,
        combinacao: this.opcaoSelecionada.itemVariacao,
      };

      this.$emit("confirmar", { combinacao: combinacaoData, quantidade: qty });
    },
  },
};
</script>

<style scoped>
.comb-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.comb-modal {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);
  width: 520px;
  max-width: 95vw;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.comb-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.comb-modal__title {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.comb-modal__close {
  background: none;
  border: none;
  font-size: 1.4rem;
  color: #64748b;
  cursor: pointer;
  line-height: 1;
  padding: 0 0.25rem;
}

.comb-modal__close:hover {
  color: #1e293b;
}

.comb-modal__produto {
  padding: 0.75rem 1.25rem;
  background: #f0f9ff;
  border-bottom: 1px solid #e0f2fe;
}

.comb-modal__produto-nome {
  font-weight: 600;
  color: #0369a1;
  font-size: 0.9rem;
}

.comb-modal__busca {
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
}

.comb-modal__busca-input {
  width: 100%;
  padding: 0.4rem 0.75rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 0.875rem;
  outline: none;
  box-sizing: border-box;
}

.comb-modal__busca-input:focus {
  border-color: var(--primary-color, #ee7361);
  box-shadow: 0 0 0 2px rgba(238, 115, 97, 0.15);
}

.comb-modal__lista {
  overflow-y: auto;
  flex: 1;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.comb-modal__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s;
  gap: 0.5rem;
}

.comb-modal__item:hover {
  background: #fde8e5;
  border-color: #f5a394;
}

.comb-modal__item--selecionado {
  background: #fde8e5;
  border-color: var(--primary-color, #ee7361);
}

.comb-modal__item--esgotado {
  opacity: 0.5;
  cursor: not-allowed;
  background: #f8fafc;
}

.comb-modal__item-info {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  flex: 1;
  min-width: 0;
}

.comb-modal__item-nome {
  font-size: 0.875rem;
  color: #1e293b;
  font-weight: 500;
}

.comb-modal__item-estoque {
  font-size: 0.75rem;
  color: #64748b;
}

.comb-modal__item-estoque--baixo {
  color: #d97706;
  font-weight: 600;
}

.comb-modal__item-estoque--esgotado {
  color: #dc2626;
  font-weight: 600;
}

.comb-modal__item-acoes {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.comb-modal__qty-wrap {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.comb-modal__qty-btn {
  width: 28px;
  height: 28px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  background: #fff;
  color: #475569;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.1s;
}

.comb-modal__qty-btn:hover {
  background: #f1f5f9;
}

.comb-modal__qty-input {
  width: 52px;
  text-align: center;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  padding: 0.25rem 0.3rem;
  font-size: 0.875rem;
  outline: none;
}

.comb-modal__qty-input:focus {
  border-color: var(--primary-color, #ee7361);
}

.comb-modal__btn-selecionar {
  font-size: 0.8rem;
  padding: 0.3rem 0.7rem;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  background: #fff;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s, border-color 0.12s;
}

.comb-modal__btn-selecionar:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}

.comb-modal__btn-selecionar--ativo {
  background: var(--primary-color, #ee7361);
  border-color: var(--primary-color, #ee7361);
  color: #fff;
}

.comb-modal__vazio {
  padding: 1.5rem;
  text-align: center;
  color: #94a3b8;
  font-size: 0.875rem;
}

.comb-modal__vazio i {
  display: block;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #cbd5e1;
}

.comb-modal__erro {
  padding: 0.5rem 1.25rem;
  font-size: 0.85rem;
  color: #b91c1c;
  background: #fef2f2;
  border-top: 1px solid #fecaca;
}

.comb-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 0.875rem 1.25rem;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
}

.comb-modal__btn {
  padding: 0.5rem 1.25rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
  transition: opacity 0.15s;
}

.comb-modal__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.comb-modal__btn--cancel {
  background: #fff;
  border-color: #cbd5e1;
  color: #475569;
}

.comb-modal__btn--cancel:hover:not(:disabled) {
  background: #f1f5f9;
}

.comb-modal__btn--confirm {
  background: var(--primary-color, #ee7361);
  color: #fff;
  border-color: var(--primary-color, #ee7361);
}

.comb-modal__btn--confirm:hover:not(:disabled) {
  background: #e05a47;
}
</style>
